export default class Node {
    constructor(name, x, y, intersectionType = null) {
        this.x = x;
        this.y = y;
        this.name = name;
        this.neighbours = [];
        this.intersectionType = intersectionType;
    }
    isAlignedTo(node) {
        return this.x === node.x || this.y === node.y;
    }
    isConnectedTo(node) {
        return this.neighbours.some(n => n === node);
    }
    connectTo(node, wire) {
        if (!this.isAlignedTo(node)) {
            throw new Error("Cannot connect 2 nodes that are not aligned (nodeA: " + this.name + " nodeB: " + node.name + ")");
        }
        if (this.isConnectedTo(node)) {
            throw new Error("This node is already connected to " + node.name);
        }
        this.neighbours.push(node);
        node.neighbours.push(this);
    }
    static distance(a, b) {
        return Math.hypot(a.x - b.x, a.y - b.y);
    }
    static direction(a, b) {
        if (a.x > b.x) {
            return { x: -1, y: 0 };
        }
        else if (a.x < b.x) {
            return { x: 1, y: 0 };
        }
        else {
            if (a.y > b.y) {
                return { x: 0, y: -1 };
            }
            else {
                return { x: 0, y: 1 };
            }
        }
    }
}
